import React, { ReactNode } from 'react';

import { Box, createStyles } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import { ContentPanel } from 'components/ExtractedContent/ContentPanel';
import { ExtractedItemsNavigation } from 'components/ExtractedContent/ExtractedItemsNavigation/ExtractedItemsNavigation';
import { SearchFormValues } from 'components/ExtractedContent/ExtractedItemsNavigation/SearchField';

const useStyles = createStyles(() => ({
  container: {
    position: 'fixed',
    top: '56px',
    left: 0,
    right: 0,
    bottom: 0,
    padding: '0 16px 16px',
    display: 'flex',
    justifyContent: 'center',
    overflow: 'hidden'
  },

  contentWrapper: {
    width: '100%',
    maxWidth: '1400px',
    overflow: 'hidden',
    height: '90%',
    maxHeight: '800px',
    margin: 'auto',
    display: 'flex'
  },

  navigationPanel: {
    height: '100%',
    flexShrink: 0,
    width: '320px',
    marginRight: '16px'
  },

  contentPanel: {
    flex: 1,
    height: '100%',
    minWidth: 0
  }
}));

interface ExtractedContentLayoutProps {
  navigationTitle: string;
  navigationTooltip: string;
  searchForm: UseFormReturnType<SearchFormValues>;
  navigationItems: ReactNode;
  mainContent: ReactNode;
}

export function ExtractedContentLayout({
  navigationTitle,
  navigationTooltip,
  searchForm,
  navigationItems,
  mainContent
}: ExtractedContentLayoutProps) {
  const { classes } = useStyles();

  return (
    <Box className={classes.container}>
      <Box className={classes.contentWrapper}>
        <Box className={classes.navigationPanel}>
          <ExtractedItemsNavigation title={navigationTitle} tooltip={navigationTooltip} searchForm={searchForm}>
            {navigationItems}
          </ExtractedItemsNavigation>
        </Box>
        <Box className={classes.contentPanel}>
          <ContentPanel>{mainContent}</ContentPanel>
        </Box>
      </Box>
    </Box>
  );
}
